import StateMachine from "javascript-state-machine/lib/state-machine.js";
import StateMachineHistory from "javascript-state-machine/lib/history";

import FootballState from "../../football/state/football-state";
import FlagFootballTransitionConfig from "./flag-football-play-transtions";

const stateConfig = {
    plugins: [new StateMachineHistory()],
    methods: {
        doTransition: function (transition) {
            this[transition]();
        }
    },
    data: {
        name: "FlagFootball"
    },
    init: FootballState.Start,
    transitions: FlagFootballTransitionConfig,
    observeUnchangedState: true
};

const FlagFootballPlayState = StateMachine.factory(stateConfig);

export default FlagFootballPlayState;
